import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useMessage } from '@tmapy/intl';
import { useDispatch, useSelector } from '@tmapy/redux';
import { actionSetLayerFeatures, EWKTToGeoJSONObject } from '@tmapy/mapcore';

import './NewOrderShpDgnAttachment.scss';

import { Badge, DangerAlert, InfoAlert, UploadDropZone } from '@tmapy/style-guide';

import { newOrderMessages } from './orderMessages';
import type { AttachmentCreateRequest } from '../../openapi/types';
import { UNMANAGED_AREA_LAYERS } from '../../areas/constants';
import { callApi } from '../../utils/api';
import { commonMessages } from '../../commonMessages';

export const NewOrderShpDgnAttachment: React.FC = () => {
  const dispatch = useDispatch();
  const formatMessage = useMessage();
  const server = useSelector((state) => state.app.config.server);
  const [isUploadError, setIsUploadError] = useState<boolean>(false);
  const [isAttachment, setIsAttachment] = useState<string>('');

  const handleUpload = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const input = e.target;
      const file = input.files![0];

      setIsUploadError(false);

      const formData = new FormData() as FormData & AttachmentCreateRequest;
      formData.set('file', file);

      const respond = await callApi(`${server}/dmx-server/file_to_polygon`, 'POST', formData);

      if (respond.data) {
        const EWKT: any = respond.data;
        const feature = EWKTToGeoJSONObject(EWKT);
        setIsAttachment(file.name ?? 'unknown');
        dispatch(actionSetLayerFeatures(UNMANAGED_AREA_LAYERS.CUSTOM_AREAS, [feature]));
      } else {
        setIsUploadError(true);
        console.error(
          `File ${file?.name ?? 'unknown'}:`,
          respond?.error?.data ?? [{ message: '', code: 'unknown_server_error' }],
        );
      }
    },
    [dispatch],
  );

  const uploadHelpText = formatMessage.fallback(['orders.attachments.uploadHelpText']);
  const uploadErrorText = formatMessage(newOrderMessages.uploadShpDgnErrorText);

  return (
    <div className='sg-u-vs-2'>
      <h3 className='sg-u-type-h2'>
        <FormattedMessage {...newOrderMessages.shpdgn} />
      </h3>

      {uploadHelpText && <InfoAlert>{uploadHelpText}</InfoAlert>}
      {isUploadError && <DangerAlert>{uploadErrorText}</DangerAlert>}

      <div className='sg-a-d-f sg-a-cg-2'>
        <div className='dmx-newOrderShpDgnAttachments-dropZone'>
          <UploadDropZone
            label={formatMessage(commonMessages.uploadDropZone)}
            btnLabel={formatMessage(commonMessages.uploadBtn)}
            name='attachments'
            isShown={true}
            onDrop={handleUpload}
          >
            {isAttachment && (
              <div className='sg-a-ml-1/2'>
                <Badge type='info'>{isAttachment}</Badge>
              </div>
            )}
          </UploadDropZone>
        </div>
      </div>
    </div>
  );
};
